const usageFlagItems = [
	{ key: "use_for_broker_updates", type: "checkbox", label: "Use for broker updates" },
	{ key: "use_for_booking", type: "checkbox", label: "Use for booking" },
	{ key: "use_for_invoicing", type: "checkbox", label: "Use for invoicing" },
];

const passwordFormDefinition = ({ isViewMode = false } = {}) => ({
	items: [
		...(isViewMode
			? [
					{
						key: "information_message",
						type: "message",
						builder: () =>
							`When this provider is selected for a purpose it overrides the default Mail Configuration for that send path only.`,
					},
					{
						key: "enabled",
						type: "text",
						label: "Status",
						builder: (item) => (item?.enabled ? "Enabled" : "Disabled"),
					},
			  ]
			: []),
		{
			type: "group",
			content: {
				items: [
					{
						key: "server_name",
						type: "text",
						label: "Host",
						required: !isViewMode,
						description: "Your Email Server Name. Ex. smtp.outlook.com",
					},
					...(isViewMode
						? [
								{
									key: "username",
									type: "text",
									label: "Username",
									builder: (item) => item?.authentication?.username ?? item?.username ?? "",
								},
						  ]
						: [
								{
									key: "port",
									type: "text",
									label: "Port",
									required: true,
									description: "Typically 587",
								},
						  ]),
				],
			},
		},
		...(isViewMode
			? []
			: [
					{
						type: "group",
						content: {
							items: [
								{
									key: "username",
									type: "email",
									label: "Username",
									required: true,
									description: "The email address you want to send your emails from.",
								},
								{
									key: "password",
									type: "password",
									label: "Password",
									required: true,
									description: "The email account password.",
								},
							],
						},
					},
			  ]),
		{
			type: "group",
			content: { items: usageFlagItems },
		},
		...(isViewMode ? [] : [{ type: "action", action: "SUBMIT", label: "Save" }]),
	],
});

const oauthFormDefinition = ({ isViewMode = false } = {}) => ({
	items: [
		{
			key: "information_message",
			type: "message",
			builder: () =>
				`When this provider is selected for a purpose it overrides the default Mail Configuration for that send path only.`,
		},
		...(isViewMode
			? [
					{
						key: "enabled",
						type: "text",
						label: "Status",
						builder: (item) => (item?.enabled ? "Enabled" : "Disabled"),
					},
			  ]
			: []),
		{
			type: "group",
			content: {
				items: [
					{
						key: "provider",
						type: "text",
						label: "Provider",
						builder: (item) => (item?.provider === "office365" ? "Office 365" : "GMAIL"),
					},
					{
						key: "username",
						type: "text",
						label: "Connected Email",
						builder: (item) => item?.authentication?.username ?? item?.username ?? "",
					},
				],
			},
		},
		{
			type: "group",
			content: { items: usageFlagItems },
		},
		...(isViewMode ? [] : [{ type: "action", action: "SUBMIT", label: "Save" }]),
	],
});

const deleteContent = {
	items: [
		{
			type: "message",
			builder: (item) =>
				`Would you like to permanently delete the email provider '${
					item?.authentication?.username || item?.username || "this provider"
				}'?`,
		},
		{
			type: "group",
			content: {
				items: [
					{ type: "action", action: "CANCEL" },
					{ type: "action", action: "DELETE" },
				],
			},
		},
	],
};

const carrierEmailProviderForm = {
	urlGET: "api/profile/carriers/:carrierId/email-providers/:providerId",
	urlPOST: "api/profile/carriers/:carrierId/email-providers",
	urlDELETE: "api/profile/carriers/:carrierId/email-providers/:providerId",
	urlPUT: "api/profile/carriers/:carrierId/email-providers/:providerId",
	idKey: "_id",
	triggerEvent: "profileRevision",
	listenEvent: "profileRevision",
	size: "max-w-lg",
	header: {
		create: { label: "Add Email Provider" },
		delete: { label: "Delete Email Provider" },
		edit: { label: "Edit Email Provider" },
		view: { label: "Email Provider Details" },
	},
	messages: { edit: { success: "Saved Successfully" }, create: { sameAs: "edit" } },
	content: {
		view: passwordFormDefinition({ isViewMode: true }),
		create: passwordFormDefinition({}),
		edit: passwordFormDefinition({}),
		delete: deleteContent,
	},
};

export const carrierEmailProviderOAuthForm = {
	urlGET: "api/profile/carriers/:carrierId/email-providers/:providerId",
	urlDELETE: "api/profile/carriers/:carrierId/email-providers/:providerId",
	urlPUT: "api/profile/carriers/:carrierId/email-providers/:providerId",
	idKey: "_id",
	triggerEvent: "profileRevision",
	listenEvent: "profileRevision",
	size: "max-w-lg",
	header: {
		delete: { label: "Delete Email Provider" },
		edit: { label: "Edit Email Provider" },
		view: { label: "Email Provider Details" },
	},
	messages: { edit: { success: "Saved Successfully" } },
	content: {
		view: oauthFormDefinition({ isViewMode: true }),
		edit: oauthFormDefinition({}),
		delete: deleteContent,
	},
};

export default carrierEmailProviderForm;
